// Auto-generated at build time — do not edit manually
export const buildVersion = {
  commit: 'e788071',
  buildDate: '2026-11-04',
};
